import React from "react";
import { Toolbar, Button } from "react-md";

const RegistrationTitleBar = ({
  onCancel,
  location = { name: "" },
  currentRegistration
}) => (
  <Toolbar
    fixed
    colored
    title={`Range Registration - ${location.name}`}
    actions={
      currentRegistration && <Button icon onClick={onCancel}>close</Button>
    }
  />
);

export default RegistrationTitleBar;



// WEBPACK FOOTER //
// ./src/registration/components/RegistrationTitleBar.jsx